import { render, staticRenderFns } from "./ProductFormVariantPreparationDays.vue?vue&type=template&id=ec84d178&"
import script from "./ProductFormVariantPreparationDays.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantPreparationDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports